<template>
  <div class="tw-bg-primary-100 tw-flex tw-items-center tw-rounded-lg tw-p-2 tw-gap-2">
    <slot />
  </div>
</template>
